import type { SVGProps } from 'react'
const SvgSyTechSolidNetworkTiers = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M7.3 15.7A5.92 5.92 0 0 1 6 12H2a9.9 9.9 0 0 0 2.46 6.54zM12 2a10 10 0 0 0-6.55 2.45l2.84 2.84A6 6 0 0 1 18 12h4A10 10 0 0 0 12 2" />
		<circle cx={8} cy={19} r={2} fillOpacity={0.24} />
		<circle cx={19} cy={16} r={2} />
		<circle cx={14} cy={20} r={2} />
		<path d="M6 12H2a10 10 0 0 0 .44 2.91l4-.79A6 6 0 0 1 6 12" />
		<circle cx={5} cy={8} r={2} fillOpacity={0.24} />
		<path d="M17.61 9.88A6 6 0 0 1 18 12h4a10 10 0 0 0-.43-2.91z" />
	</svg>
)
export default SvgSyTechSolidNetworkTiers
